import { HIDE_MESSAGE } from "../actions/systemMessage";

export const awaitHideAction = (action) => action.type === HIDE_MESSAGE;

export const getErrorMessage = (state) => state.systemMessages;
